webpackJsonp([252169175765715],{

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NominateAStudent = function (_React$Component) {
	    _inherits(NominateAStudent, _React$Component);
	
	    function NominateAStudent() {
	        _classCallCheck(this, NominateAStudent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    NominateAStudent.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Hero2.default, {
	                title: 'Nominate A Student'
	            }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'page-intro' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '8', offsetL: '2', tablet: '12' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2', style: { marginBottom: '20px' } },
	                        'WE INVITE EDUCATORS TO NOMINATE STUDENTS FOR GLOBAL CITIZEN YEAR.'
	                    ),
	                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '<p style="margin-bottom: 15px;">Global Citizen Year is a nonprofit pioneering a model that wraps curriculum and coaching around real-world experience to transform the trajectory of our most promising young leaders. Working with colleges, companies and community partners, Global Citizen Year is forging a new educational pathway to launch the leaders our world needs now.</p>\n                            <p>We run 2 programs:</p>\n                            <ul>\n                                <li><em>The Academy:</em> a semester-long virtual leadership program for students aged 17-21</li>\n                                <li><em>The Fellowship:</em> a school-year long deep immersion fellowship abroad.</li>\n                            </ul>\n                            <p style="margin-bottom: 15px;">We\u2019d love your help finding students who are the right fit for our programs. The nomination is completely non-binding. We\u2019ll reach out to any student you nominate to let them know they\u2019ve been nominated, share more information, help them figure out which program is right for them and guide them through the application process.</p>\n                            <p style="margin-bottom: 15px;">Take 5 min to fill out this form and we\u2019ll follow up with the student from there!</p>' } })
	                )
	            ),
	            _react2.default.createElement('iframe', { src: '/nominate-form.html', frameBorder: '0', width: '100%', height: '650px', style: { border: '0px' } })
	        );
	    };
	
	    return NominateAStudent;
	}(_react2.default.Component);
	
	exports.default = NominateAStudent;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-nominate-a-student-js-a47313f843f784cc117a.js